import { z } from 'zod'

import { schemas } from '~interface/zod-schema'

import { Identity0 } from './cases'
import { Process3 } from './processes'

export type ContactEmail0 = z.infer<typeof schemas.ContactEmail0>

export enum EmailParticipantType {
  to = 'to',
  cc = 'cc',
  bcc = 'bcc',
  from = 'from',
}

export type Email1 = z.infer<typeof schemas.Email1>
export type EmailParticipant0 = z.infer<typeof schemas.EmailParticipant0>

export type VerifyOptions = z.infer<typeof schemas.VerifyOptions>
export type VerifyOptionsTypeEnum = z.infer<typeof schemas.VerifyOptionsTypeEnum>
export const VerifyOptionsTypeVerifyAdmin: VerifyOptionsTypeEnum = 'admin'
export const VerifyOptionsTypeVerifyApply: VerifyOptionsTypeEnum = 'apply'
export const VerifyOptionsTypeVerifyPayment: VerifyOptionsTypeEnum = 'payment'
export const VerifyOptionsTypeVerifyStandard: VerifyOptionsTypeEnum = 'standard'
export const VerifyOptionsTypeVerifyThread: VerifyOptionsTypeEnum = 'thread'

export type VerifyAdmin = z.infer<typeof schemas.VerifyAdmin>
export type VerifyApply = z.infer<typeof schemas.VerifyApply>
export type VerifyPayment = z.infer<typeof schemas.VerifyPayment>
export type VerifyStandard = z.infer<typeof schemas.VerifyStandard>
export type VerifyThread = z.infer<typeof schemas.VerifyThread>

export const createVerifyApply = (process: Process3): VerifyOptions => ({
  type: VerifyOptionsTypeVerifyApply,
  apply: { process: process },
})
export const createVerifyAdmin = (identity: Identity0): VerifyOptions => ({
  type: VerifyOptionsTypeVerifyAdmin,
  admin: { identity: identity },
})

export const createVerifyStandard = (uri: string | null): VerifyOptions => ({
  type: VerifyOptionsTypeVerifyStandard,
  standard: { uri: uri },
})
